import React from "react";
var __jsx = React.createElement;
import useIsMobile from "@hooks/useIsMobile";
import MobileScreenView from "@componentsShared/mobileScreenView/MobileScreenView";
import PriceOfferCitySearch from "@/pages/price-offer/components/PriceOfferCitySearch";
import { AnimatePresence } from "framer-motion";
import { useTranslation } from "@i18n";
import SharedPopUp from "@componentsShared/BottomSheetPopup__OLD/SharedPopUp";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
var PriceOfferCitySearchRenderer = function PriceOfferCitySearchRenderer(_ref) {
  var screenState = _ref.screenState;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _usePriceOfferContext = usePriceOfferContext(),
    actions = _usePriceOfferContext.actions;
  if (isMobile) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AnimatePresence, null, screenState.value && /*#__PURE__*/React.createElement(MobileScreenView, {
      onClose: function onClose() {
        actions.resetCitiesSearch();
        screenState.setFalse();
      },
      title: tShort("price_offer/change_city_screen_title", {
        ns: "web_sell_trade"
      }),
      icon: {
        icon: "material-symbols--close-small-rounded",
        width: 6,
        height: 6,
        className: "text-primary"
      }
    }, /*#__PURE__*/React.createElement(PriceOfferCitySearch, {
      onSubmit: function onSubmit() {
        return screenState.setFalse();
      }
    }))));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SharedPopUp, {
    show: screenState.value,
    onClose: function onClose() {
      actions.resetCitiesSearch();
      screenState.setFalse();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-10 py-8"
  }, /*#__PURE__*/React.createElement(PriceOfferCitySearch, {
    onSubmit: function onSubmit() {
      return screenState.setFalse();
    }
  }))));
};
export default PriceOfferCitySearchRenderer;